import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { sizes } from '@twistopayments/design-system/icons/constants'
import { breakpoint, transitions } from '@twistopayments/design-system/styles'

export const navigation = (theme: Theme) => css`
  position: relative;
  padding: ${theme.spacing[24]};

  ${breakpoint.up('sm')} {
    padding: ${theme.spacing[24]};
  }
`

export const separator = (theme: Theme) => css`
  border-bottom: 1px solid ${theme.palette.tertiary.mediumContrast};
`

export const backIcon = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${theme.spacing[32]};
  height: ${theme.spacing[32]};
  padding: 0;
  background-color: ${theme.palette.tertiary.mediumContrast};
  border-radius: ${theme.borderRadius.circle};
  transition: background-color ${transitions.default};
  ${sizes[18]};

  ${breakpoint.up('sm')} {
    width: ${theme.spacing[40]};
    height: ${theme.spacing[40]};
    ${sizes[24]};
  }

  path {
    fill: ${theme.palette.tertiary.upperMediumContrast};
    transition: fill ${transitions.default};
  }
`

export const backButton = (theme: Theme) => css`
  margin-right: ${theme.spacing[16]};
  padding: ${theme.spacing[4]};

  ${breakpoint.up('sm')} {
    padding: ${theme.spacing[8]};
  }
`

export const title = (theme: Theme) => css`
  font-size: ${theme.typography.app.titleMobile.fontSize}px;
  line-height: ${theme.typography.app.titleMobile.lineHeight}px;
  letter-spacing: ${theme.typography.app.titleMobile.letterSpacing}px;

  ${breakpoint.up('sm')} {
    font-size: ${theme.typography.app.title.fontSize}px;
    line-height: ${theme.typography.app.title.lineHeight}px;
    letter-spacing: ${theme.typography.app.title.letterSpacing}px;
  }
`

export const adornment = css`
  flex-grow: 1;
  width: auto;
`
